import React, { useEffect, useRef } from "react"

export const Modal = ({
  id,
  children,
  title,
  isOpen,
  setIsOpen,
  onConfirm,
  disabled,
  extraButton,
  confirmText,
  size='medium'
}) => {
  useEffect(() => {
    if (modalRef.current) {
      if (isOpen)
        showModal(modalRef.current)
      else {
        closeModal(modalRef.current)
      }
    }
  }, [isOpen])

  const modalRef = useRef(null)

  const handleClickOutside = e => {
    if (e.target == modalRef.current) setIsOpen(false)
  }

  return (
    <div
      id              = {id}
      className       = "modal fade"
      tabIndex        = "-1"
      aria-labelledby = {id}
      aria-hidden     = "true"
      ref             = {modalRef}
      onClick         = {e => handleClickOutside(e)}
    >
      <div className = {`modal-dialog ${size}`}>
        <div className = "modal-content modal-filter">
          <div className = "modal-header">
              <h5 className = "modal-title mt-2 mb-3">
                {title}
              </h5>

            <button 
              type      = "button" 
              className = "close" 
              onClick   = {() => setIsOpen(false)}>
              <span>×</span>
            </button>
          </div>

          <div className="modal-body" style={{maxHeight: '70vh', overflowY: 'scroll'}}>
            {isOpen && children}
          </div>

          <div className="modal-buttons">
          {extraButton}
          <button 
            className = "btn btn-secondary" 
            onClick   = {() => setIsOpen(false)}
          >
            {I18n.t('button.cancel')}
          </button>

          <button 
            className = "btn btn-primary" 
            onClick   = {onConfirm}
            disabled  = {disabled}
          >
            {confirmText}
          </button>
        </div>
        </div>
      </div>
    </div>
  )
}
